import View                    from '@widesk-ui/components/View';
import Tooltip                 from '@widesk-ui/components/Tooltip';
import { observer }            from 'mobx-react-lite';
import React                   from 'react';
import { CloudUploadOutlined } from '@ant-design/icons';
import { SelectOutlined }      from '@ant-design/icons';
import leftSidebarStore        from '@/TokamapEditor/stores/leftSidebarStore';
import currentEditorStore      from '@/TokamapEditor/stores/currentEditorStore';
import useDesignTokens         from '@/hooks/useDesignTokens';

const PlanImportButtons = observer(() => {
	const editor = currentEditorStore.get;

	// L'outil zone peut se ranger sans qu'on le lui demande (Escape, ou le démarrage d'un dessin de
	// forme) : on suit son état par l'évènement, jamais en le déduisant du clic.
	const [regionToolActive, setRegionToolActive] = React.useState(false);

	React.useEffect(() => {
		if (!editor) return;

		return editor.mapAdapter.on(event => {
			if (event.type === 'region:tool-changed') setRegionToolActive(event.active);
		});
	}, [editor]);

	const importOpened = leftSidebarStore.options.reference === 'plan-import';
	const zoneOpened = leftSidebarStore.options.reference === 'plan-zone';

	return (
		<View row centerV gap={2} px={4}>
			<SegmentButton
				title="Importer un plan"
				active={importOpened}
				onClick={() => importOpened ? leftSidebarStore.close() : leftSidebarStore.openPlanImport()}
			>
				<CloudUploadOutlined style={{ fontSize: 17 }} />
			</SegmentButton>

			<SegmentButton
				title="Zone d'analyse (Z)"
				active={regionToolActive || zoneOpened}
				onClick={() => zoneOpened ? leftSidebarStore.close() : leftSidebarStore.openPlanZone()}
			>
				<SelectOutlined style={{ fontSize: 17 }} />
			</SegmentButton>
		</View>
	);
});

const SegmentButton = (props: { title: string; active: boolean; onClick: () => void; children: React.ReactNode; }) => {
	const tokens = useDesignTokens();

	return (
		<Tooltip title={props.title}>
			<div>
				<View
					h={30}
					w={30}
					br={8}
					center
					pointer
					color={props.active ? tokens.color.primary : tokens.text.secondary}
					bg={props.active ? tokens.fill.subtle : undefined}
					hover={{ bg: tokens.surface.subtle, color: props.active ? tokens.color.primary : tokens.text.default }}
					onClick={props.onClick}
				>
					{props.children}
				</View>
			</div>
		</Tooltip>
	);
};

export default PlanImportButtons;
